export async function getTransactionsTransfers(transactionsids: string) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_ADMIN_ACCESS}/fetchTransactionDetailsByTransactionsIds?transactionsids=${transactionsids}`
    );
    const data = await response.json();
    return data.map((item: any, index: any) => ({
      id: index,
      date: item.datetransaction,
      typeconecs: item.typeconecs,
      typetransaction: item.typetransactions,
      montant: item.montant,
    }));
  } catch (error) {
    return [];
  }
}

function jsonToCsv(json: any) {
  if (!json || json.length === 0) {
    return "";
  }

  const csvRows = [];
  const headers = Object.keys(json[0]);
  csvRows.push(headers.join(","));

  for (const row of json) {
    const values = headers.map((header) => {
      const value = row[header] === undefined || row[header] === null ? "" : row[header];
      const escaped = String(value).replace(/"/g, '\\"'); 
      return `"${escaped}"`;
    });
    csvRows.push(values.join(","));
  }
  return csvRows.join("\n");
}


  export async function downloadCsv (transactionsids: any,date : string)  {
    const transactions = await getTransactionsTransfers(transactionsids);
    const csv = jsonToCsv(transactions);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${date}_transactions.csv`);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }